webpackJsonp([49720745202621],{

/***/ 218:
/***/ (function(module, exports) {

	module.exports = {"data":{"allImageSharp":{"edges":[{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAJABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAUDBP/EABYBAQEBAAAAAAAAAAAAAAAAAAMCBP/aAAwDAQACEAMQAAABk1cOoNYSv//EABcQAAMBAAAAAAAAAAAAAAAAAAECEDP/2gAIAQEAAQUCJdXh3n//xAAXEQADAQAAAAAAAAAAAAAAAAABAhEQ/9oACAEDAQE/AUEuf//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AVn/xAAXEAADAQAAAAAAAAAAAAAAAAABEBEx/9oACAEBAAY/AqdYf//EABoQAQACAwEAAAAAAAAAAAAAAAEQEQBBkaH/2gAIAQEAAT8htOr1lLS8jxT/AP/aAAwDAQACAAMAAAAQ7A//xAAXEQADAQAAAAAAAAAAAAAAAAAQESFB/9oACAEDAQE/EGq0f//EABURAQEAAAAAAAAAAAAAAAAAABEQ/9oACAECAQE/EGJ//8QAGxABAAMBAAMAAAAAAAAAAAAAAQARIUEQUaH/2gAIAQEAAT8QFqxC6bnPW1C+AaL1jOs+RDx//9k=","aspectRatio":2.1333333333333333,"src":"/static/logo-usi-4182c311ee2926a2d240792747257513-381d6.jpg","srcSet":"/static/logo-usi-4182c311ee2926a2d240792747257513-62f05.jpg 200w,\n/static/logo-usi-4182c311ee2926a2d240792747257513-dc2b4.jpg 400w,\n/static/logo-usi-4182c311ee2926a2d240792747257513-381d6.jpg 800w,\n/static/logo-usi-4182c311ee2926a2d240792747257513-e5d70.jpg 1200w,\n/static/logo-usi-4182c311ee2926a2d240792747257513-0e8f1.jpg 1280w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwACBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAeSqaCkj/8QAGhAAAgIDAAAAAAAAAAAAAAAAAQIAEBESE//aAAgBAQABBQILFLZ63qDP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFhAAAwAAAAAAAAAAAAAAAAAAACAx/9oACAEBAAY/Air/AP/EABgQAQEBAQEAAAAAAAAAAAAAAAEAESFR/9oACAEBAAE/IUIGPWYyhxCCDso1v//aAAwDAQACAAMAAAAQI8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAaEAEBAQADAQAAAAAAAAAAAAABEQAhMUFx/9oACAEBAAE/EHm8ySHeDpUEDl1MZ24fcH1O89Gr7v/Z","aspectRatio":1.550387596899225,"src":"/static/interviste_base-69e591f22bc7f0e6b8e5ce6dafc9aec3-381d6.jpg","srcSet":"/static/interviste_base-69e591f22bc7f0e6b8e5ce6dafc9aec3-62f05.jpg 200w,\n/static/interviste_base-69e591f22bc7f0e6b8e5ce6dafc9aec3-dc2b4.jpg 400w,\n/static/interviste_base-69e591f22bc7f0e6b8e5ce6dafc9aec3-381d6.jpg 800w,\n/static/interviste_base-69e591f22bc7f0e6b8e5ce6dafc9aec3-e5d70.jpg 1200w,\n/static/interviste_base-69e591f22bc7f0e6b8e5ce6dafc9aec3-d14e0.jpg 1600w,\n/static/interviste_base-69e591f22bc7f0e6b8e5ce6dafc9aec3-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwABBf/EABYBAQEBAAAAAAAAAAAAAAAAAAECA//aAAwDAQACEAMQAAAB46rsalLD/8QAGhABAAIDAQAAAAAAAAAAAAAAAQACEBESE//aAAgBAQABBQIqyrbfq55Gf//EABYRAQEBAAAAAAAAAAAAAAAAAAARIv/aAAgBAwEBPwGNP//EABYRAQEBAAAAAAAAAAAAAAAAAAARIf/aAAgBAgEBPwGsf//EABcQAAMBAAAAAAAAAAAAAAAAAAABMSD/2gAIAQEABj8CKRY//8QAGBABAQEBAQAAAAAAAAAAAAAAAQARIVH/2gAIAQEAAT8hIwMesxklHhBB2Wanb//aAAwDAQACAAMAAAAQFz//xAAYEQACAwAAAAAAAAAAAAAAAAAAEQExUf/aAAgBAwEBPxCFoWj/xAAXEQEAAwAAAAAAAAAAAAAAAAAAARFx/9oACAECAQE/EJsw/8QAGBABAQEBAQAAAAAAAAAAAAAAAREAMUH/2gAIAQEAAT8QUDWSQ7h6VBA4WBU64XuC/WdzW5e7/9k=","aspectRatio":1.550387596899225,"src":"/static/interviste_hover-774b8e8b7b1fadf70aa18978549e85c7-381d6.jpg","srcSet":"/static/interviste_hover-774b8e8b7b1fadf70aa18978549e85c7-62f05.jpg 200w,\n/static/interviste_hover-774b8e8b7b1fadf70aa18978549e85c7-dc2b4.jpg 400w,\n/static/interviste_hover-774b8e8b7b1fadf70aa18978549e85c7-381d6.jpg 800w,\n/static/interviste_hover-774b8e8b7b1fadf70aa18978549e85c7-e5d70.jpg 1200w,\n/static/interviste_hover-774b8e8b7b1fadf70aa18978549e85c7-d14e0.jpg 1600w,\n/static/interviste_hover-774b8e8b7b1fadf70aa18978549e85c7-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAECAwT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHLVBgIP//EABkQAAMAAwAAAAAAAAAAAAAAAAABEQISE//aAAgBAQABBQLoh5JlIQ1P/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGhAAAQUBAAAAAAAAAAAAAAAAAAERICExQf/aAAgBAQAGPwLpTmLD/8QAGxAAAQQDAAAAAAAAAAAAAAAAAAFRcZERMfD/2gAIAQEAAT8hVmppFDohMyckf//aAAwDAQACAAMAAAAQ4w//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAeEAEAAgIBBQAAAAAAAAAAAAABABEhMdFBUWFxof/aAAgBAQABPxB4uKTS3IDE5XdvGeZcUV7bx9luofY8z//Z","aspectRatio":1.550387596899225,"src":"/static/conferenze_base-f1f5fa4e7318d0ea21159ec6850efa54-381d6.jpg","srcSet":"/static/conferenze_base-f1f5fa4e7318d0ea21159ec6850efa54-62f05.jpg 200w,\n/static/conferenze_base-f1f5fa4e7318d0ea21159ec6850efa54-dc2b4.jpg 400w,\n/static/conferenze_base-f1f5fa4e7318d0ea21159ec6850efa54-381d6.jpg 800w,\n/static/conferenze_base-f1f5fa4e7318d0ea21159ec6850efa54-e5d70.jpg 1200w,\n/static/conferenze_base-f1f5fa4e7318d0ea21159ec6850efa54-d14e0.jpg 1600w,\n/static/conferenze_base-f1f5fa4e7318d0ea21159ec6850efa54-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAcixUzlA/8QAGhABAAIDAQAAAAAAAAAAAAAAAgABERIhA//aAAgBAQABBQI+nE1Z7DmzteN1P//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAIDAQAAAAAAAAAAAAAAABARAAEhMf/aAAgBAQAGPwLkvA2f/8QAGRABAQEBAQEAAAAAAAAAAAAAAQARUSFB/9oACAEBAAE/IV1vqIonwMEcJBuu72e1/9oADAMBAAIAAwAAABDgD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABoQAQEBAQADAAAAAAAAAAAAAAERACExQXH/2gAIAQEAAT8QeCpKV5qIC0gWmFOBL4zuY1Cc18fAfTmW3n4G/9k=","aspectRatio":1.550387596899225,"src":"/static/mappe_base-d889321c830139b8b201446c36d2821c-381d6.jpg","srcSet":"/static/mappe_base-d889321c830139b8b201446c36d2821c-62f05.jpg 200w,\n/static/mappe_base-d889321c830139b8b201446c36d2821c-dc2b4.jpg 400w,\n/static/mappe_base-d889321c830139b8b201446c36d2821c-381d6.jpg 800w,\n/static/mappe_base-d889321c830139b8b201446c36d2821c-e5d70.jpg 1200w,\n/static/mappe_base-d889321c830139b8b201446c36d2821c-d14e0.jpg 1600w,\n/static/mappe_base-d889321c830139b8b201446c36d2821c-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMCBAX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHOnRBgkP/EABkQAAIDAQAAAAAAAAAAAAAAAAACARARIf/aAAgBAQABBQJTBp7f/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGRAAAgMBAAAAAAAAAAAAAAAAAAERIDIx/9oACAEBAAY/AtM2zs0//8QAGRABAQEBAQEAAAAAAAAAAAAAAQARUSFB/9oACAEBAAE/IfW4R8lQ1NeyvYv/2gAMAwEAAgADAAAAEGPP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFhUdH/2gAIAQEAAT8QQgSaFHnSVBXrh8heLaENhS5XymLE/9k=","aspectRatio":1.550387596899225,"src":"/static/pubblicazioni_base-0450bb7d723fdce7514cbdbbb84d1352-381d6.jpg","srcSet":"/static/pubblicazioni_base-0450bb7d723fdce7514cbdbbb84d1352-62f05.jpg 200w,\n/static/pubblicazioni_base-0450bb7d723fdce7514cbdbbb84d1352-dc2b4.jpg 400w,\n/static/pubblicazioni_base-0450bb7d723fdce7514cbdbbb84d1352-381d6.jpg 800w,\n/static/pubblicazioni_base-0450bb7d723fdce7514cbdbbb84d1352-e5d70.jpg 1200w,\n/static/pubblicazioni_base-0450bb7d723fdce7514cbdbbb84d1352-d14e0.jpg 1600w,\n/static/pubblicazioni_base-0450bb7d723fdce7514cbdbbb84d1352-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAgP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFPRcKkB//EABkQAAMBAQEAAAAAAAAAAAAAAAABEQIDEv/aAAgBAQABBQLm1NNFM9Jn0U//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAXEAADAQAAAAAAAAAAAAAAAAAAECEy/9oACAEBAAY/AqRZf//EABgQAQEBAQEAAAAAAAAAAAAAAAEAETFx/9oACAEBAAE/IQ+0Q4lb2yDEtMwtX//aAAwDAQACAAMAAAAQsw//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAZEAEBAQEBAQAAAAAAAAAAAAABEQAxUXH/2gAIAQEAAT8QICioFyNpGVTIbXfcZKXqvcrjrXuhyHw3/9k=","aspectRatio":1.550387596899225,"src":"/static/eventi_base-a68a444bdf22e95ed5879abf444625f9-381d6.jpg","srcSet":"/static/eventi_base-a68a444bdf22e95ed5879abf444625f9-62f05.jpg 200w,\n/static/eventi_base-a68a444bdf22e95ed5879abf444625f9-dc2b4.jpg 400w,\n/static/eventi_base-a68a444bdf22e95ed5879abf444625f9-381d6.jpg 800w,\n/static/eventi_base-a68a444bdf22e95ed5879abf444625f9-e5d70.jpg 1200w,\n/static/eventi_base-a68a444bdf22e95ed5879abf444625f9-d14e0.jpg 1600w,\n/static/eventi_base-a68a444bdf22e95ed5879abf444625f9-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQCA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAYc9xOpH/8QAGRAAAgMBAAAAAAAAAAAAAAAAAAECERIQ/9oACAEBAAEFAq7mxQMI/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGRABAQEBAQEAAAAAAAAAAAAAAREAIUEQ/9oACAEBAAE/IV+R0gd3fMgTAEr8P//aAAwDAQACAAMAAAAQoA//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMUFxUWGB/9oACAEBAAE/EH2oO8ym4u1xqObQTuGUoHjb9iYULbcea79Yn//Z","aspectRatio":1.550387596899225,"src":"/static/progetto_base-6be57dac7d281c9cf99d3743361540c8-381d6.jpg","srcSet":"/static/progetto_base-6be57dac7d281c9cf99d3743361540c8-62f05.jpg 200w,\n/static/progetto_base-6be57dac7d281c9cf99d3743361540c8-dc2b4.jpg 400w,\n/static/progetto_base-6be57dac7d281c9cf99d3743361540c8-381d6.jpg 800w,\n/static/progetto_base-6be57dac7d281c9cf99d3743361540c8-e5d70.jpg 1200w,\n/static/progetto_base-6be57dac7d281c9cf99d3743361540c8-d14e0.jpg 1600w,\n/static/progetto_base-6be57dac7d281c9cf99d3743361540c8-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAMC/9oADAMBAAIQAxAAAAHKsUNs5Qs//8QAGxABAAICAwAAAAAAAAAAAAAAAgABESEDEhP/2gAIAQEAAQUCPLpNWdw5s9rx6Kf/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEiH/2gAIAQMBAT8Bpj//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwGH/8QAGRAAAgMBAAAAAAAAAAAAAAAAAAEQETEh/9oACAEBAAY/AsHyG7jT/8QAHBABAAIBBQAAAAAAAAAAAAAAAQARECExQVGx/9oACAEBAAE/IUteqEXiJwGDoCJNtu63wP/aAAwDAQACAAMAAAAQ18//xAAYEQADAQEAAAAAAAAAAAAAAAAAAREhUf/aAAgBAwEBPxBtNJ0f/8QAFhEAAwAAAAAAAAAAAAAAAAAAABEh/9oACAECAQE/EEcKf//EABoQAQEBAQADAAAAAAAAAAAAAAERACExQXH/2gAIAQEAAT8QaDpKVhr+C0hVMKcSXxnYxqE5rcxJ9CZVvHwN/9k=","aspectRatio":1.550387596899225,"src":"/static/mappe_hover-f1168d516a276405143d99e4366dd039-381d6.jpg","srcSet":"/static/mappe_hover-f1168d516a276405143d99e4366dd039-62f05.jpg 200w,\n/static/mappe_hover-f1168d516a276405143d99e4366dd039-dc2b4.jpg 400w,\n/static/mappe_hover-f1168d516a276405143d99e4366dd039-381d6.jpg 800w,\n/static/mappe_hover-f1168d516a276405143d99e4366dd039-e5d70.jpg 1200w,\n/static/mappe_hover-f1168d516a276405143d99e4366dd039-d14e0.jpg 1600w,\n/static/mappe_hover-f1168d516a276405143d99e4366dd039-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIEA//EABYBAQEBAAAAAAAAAAAAAAAAAAMBAv/aAAwDAQACEAMQAAABi0nDdRS4/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAERAgMS/9oACAEBAAEFAubU00imOkz7pT//xAAWEQADAAAAAAAAAAAAAAAAAAAQESH/2gAIAQMBAT8BcH//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwGH/8QAGBAAAwEBAAAAAAAAAAAAAAAAABAhMTL/2gAIAQEABj8CpFyYv//EABkQAQEBAAMAAAAAAAAAAAAAAAEAESExcf/aAAgBAQABPyEvtEdJSvNjAJQzFq//2gAMAwEAAgADAAAAEID/AP/EABcRAAMBAAAAAAAAAAAAAAAAAAABESH/2gAIAQMBAT8QS4Kf/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EFbP/8QAGhABAQEBAAMAAAAAAAAAAAAAAREAMSFRcf/aAAgBAQABPxAKOKgXOXgyqZCp8+8KLvVe5DDWvdDkPhv/2Q==","aspectRatio":1.550387596899225,"src":"/static/eventi_hover-68dbb18b9e7e2325574f7f9a2687ee49-381d6.jpg","srcSet":"/static/eventi_hover-68dbb18b9e7e2325574f7f9a2687ee49-62f05.jpg 200w,\n/static/eventi_hover-68dbb18b9e7e2325574f7f9a2687ee49-dc2b4.jpg 400w,\n/static/eventi_hover-68dbb18b9e7e2325574f7f9a2687ee49-381d6.jpg 800w,\n/static/eventi_hover-68dbb18b9e7e2325574f7f9a2687ee49-e5d70.jpg 1200w,\n/static/eventi_hover-68dbb18b9e7e2325574f7f9a2687ee49-d14e0.jpg 1600w,\n/static/eventi_hover-68dbb18b9e7e2325574f7f9a2687ee49-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAADAv/aAAwDAQACEAMQAAABVnmBtcLlH//EABoQAAMAAwEAAAAAAAAAAAAAAAABAhAREiH/2gAIAQEAAQUCn0cl76G3j//EABYRAQEBAAAAAAAAAAAAAAAAAAAREv/aAAgBAwEBPwHav//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/AYf/xAAaEAABBQEAAAAAAAAAAAAAAAABAAIQETEz/9oACAEBAAY/AjTyF0K242P/xAAZEAEBAAMBAAAAAAAAAAAAAAABACFRoeH/2gAIAQEAAT8hzAYcEniTHXC7thF//9oADAMBAAIAAwAAABDoP//EABcRAQEBAQAAAAAAAAAAAAAAAAERACH/2gAIAQMBAT8QBOmabv/EABcRAAMBAAAAAAAAAAAAAAAAAAABETH/2gAIAQIBAT8Q2JQ//8QAHBABAAIDAAMAAAAAAAAAAAAAAQARITFBcZHw/9oACAEBAAE/EEALCocUdSV7sr41HBy4PWJsiLlLKDy48Pmf/9k=","aspectRatio":1.550387596899225,"src":"/static/pubblicazioni_hover-6f4093a0aaecc76afab6f92d52c905e8-381d6.jpg","srcSet":"/static/pubblicazioni_hover-6f4093a0aaecc76afab6f92d52c905e8-62f05.jpg 200w,\n/static/pubblicazioni_hover-6f4093a0aaecc76afab6f92d52c905e8-dc2b4.jpg 400w,\n/static/pubblicazioni_hover-6f4093a0aaecc76afab6f92d52c905e8-381d6.jpg 800w,\n/static/pubblicazioni_hover-6f4093a0aaecc76afab6f92d52c905e8-e5d70.jpg 1200w,\n/static/pubblicazioni_hover-6f4093a0aaecc76afab6f92d52c905e8-d14e0.jpg 1600w,\n/static/pubblicazioni_hover-6f4093a0aaecc76afab6f92d52c905e8-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIBAwT/xAAVAQEBAAAAAAAAAAAAAAAAAAABA//aAAwDAQACEAMQAAABzUoTtIon/8QAGRAAAgMBAAAAAAAAAAAAAAAAAAECAxES/9oACAEBAAEFAnbEc0zTDDk//8QAFxEBAAMAAAAAAAAAAAAAAAAAAAERIf/aAAgBAwEBPwG5a//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/AYf/xAAZEAEAAgMAAAAAAAAAAAAAAAABADEgIZH/2gAIAQEABj8Cp5NDKcP/xAAaEAABBQEAAAAAAAAAAAAAAAAAARExcYHw/9oACAEBAAE/IQKZGHVC45pLIf/aAAwDAQACAAMAAAAQ1N//xAAWEQEBAQAAAAAAAAAAAAAAAAABEDH/2gAIAQMBAT8QW2P/xAAWEQEBAQAAAAAAAAAAAAAAAAABACH/2gAIAQIBAT8QAWX/xAAeEAEAAgIBBQAAAAAAAAAAAAABABEhMdFBUWFxof/aAAgBAQABPxBAtJARCgCpSu7eM8y6mPbePst1T2PM/9k=","aspectRatio":1.550387596899225,"src":"/static/conferenze_hover-55472263884d2dcb4c264b1681698671-381d6.jpg","srcSet":"/static/conferenze_hover-55472263884d2dcb4c264b1681698671-62f05.jpg 200w,\n/static/conferenze_hover-55472263884d2dcb4c264b1681698671-dc2b4.jpg 400w,\n/static/conferenze_hover-55472263884d2dcb4c264b1681698671-381d6.jpg 800w,\n/static/conferenze_hover-55472263884d2dcb4c264b1681698671-e5d70.jpg 1200w,\n/static/conferenze_hover-55472263884d2dcb4c264b1681698671-d14e0.jpg 1600w,\n/static/conferenze_hover-55472263884d2dcb4c264b1681698671-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABAv/EABcBAAMBAAAAAAAAAAAAAAAAAAABAwT/2gAMAwEAAhADEAAAAQ8oyWg8mF//xAAZEAACAwEAAAAAAAAAAAAAAAAAAQIREhD/2gAIAQEAAQUCrubFAwj/xAAWEQEBAQAAAAAAAAAAAAAAAAAAERL/2gAIAQMBAT8BjL//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPwGq/8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGRABAAMBAQAAAAAAAAAAAAAAAQARIUEQ/9oACAEBAAE/IV8plUGzeRAqAFC+H//aAAwDAQACAAMAAAAQiD//xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8QttP/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPxAh/8QAHRABAAICAgMAAAAAAAAAAAAAAQARITFBcVFhgf/aAAgBAQABPxB9qDvMpuLu8ajm0E7hlKB42/YmoFtvmLbu/U//2Q==","aspectRatio":1.550387596899225,"src":"/static/progetto_hover-f322e42de41e4a45305143a0b1f668d3-381d6.jpg","srcSet":"/static/progetto_hover-f322e42de41e4a45305143a0b1f668d3-62f05.jpg 200w,\n/static/progetto_hover-f322e42de41e4a45305143a0b1f668d3-dc2b4.jpg 400w,\n/static/progetto_hover-f322e42de41e4a45305143a0b1f668d3-381d6.jpg 800w,\n/static/progetto_hover-f322e42de41e4a45305143a0b1f668d3-e5d70.jpg 1200w,\n/static/progetto_hover-f322e42de41e4a45305143a0b1f668d3-d14e0.jpg 1600w,\n/static/progetto_hover-f322e42de41e4a45305143a0b1f668d3-fbf2e.jpg 2000w","sizes":"(max-width: 800px) 100vw, 800px"}}},{"node":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAASABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIEAQX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAH0Lx9NqQkLB//EABwQAAEDBQAAAAAAAAAAAAAAAAEAAhEDEBIgIf/aAAgBAQABBQLLs2h6pku1/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGRAAAQUAAAAAAAAAAAAAAAAAAQAQESAx/9oACAEBAAY/AnklbX//xAAbEAEBAAEFAAAAAAAAAAAAAAABAFEQETFBcf/aAAgBAQABPyFZC7yThdSjyPNcRf/aAAwDAQACAAMAAAAQYwcA/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAGxAAAwEBAAMAAAAAAAAAAAAAAAERMSEQQYH/2gAIAQEAAT8QUFVGvZTSR7sj5s+Dk5ErIjEuD3wwf//Z","aspectRatio":1.09519934906428,"src":"/static/splash-dddd9df04fc18893a27a6f87ab5ecd86-381d6.jpg","srcSet":"/static/splash-dddd9df04fc18893a27a6f87ab5ecd86-62f05.jpg 200w,\n/static/splash-dddd9df04fc18893a27a6f87ab5ecd86-dc2b4.jpg 400w,\n/static/splash-dddd9df04fc18893a27a6f87ab5ecd86-381d6.jpg 800w,\n/static/splash-dddd9df04fc18893a27a6f87ab5ecd86-e5d70.jpg 1200w,\n/static/splash-dddd9df04fc18893a27a6f87ab5ecd86-d14e0.jpg 1600w,\n/static/splash-dddd9df04fc18893a27a6f87ab5ecd86-9e67f.jpg 2400w,\n/static/splash-dddd9df04fc18893a27a6f87ab5ecd86-ecbf2.jpg 2692w","sizes":"(max-width: 800px) 100vw, 800px"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _it = __webpack_require__(402);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _layoutIt = __webpack_require__(218);
	
	var _layoutIt2 = _interopRequireDefault(_layoutIt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_it2.default, _extends({}, props, _layoutIt2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	(function() {
	  'use strict';
	
	  // desiredOffset - page offset to scroll to
	  // speed - duration of the scroll per 1000px
	  function __ANIMATE_SCROLL_TO(desiredOffset) {
	    var userOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var options = {
	      speed: 500,
	      minDuration: 250,
	      maxDuration: 1500,
	      cancelOnUserAction: true,
	      element: window,
	      horizontal: false,
	      onComplete: undefined,
	      passive: true,
	      offset: 0
	    };
	
	    var optionsKeys = Object.keys(options);
	
	    // Override default options
	    for (var i = 0; i < optionsKeys.length; i++) {
	      var key = optionsKeys[i];
	
	      if (typeof userOptions[key] !== 'undefined') {
	        options[key] = userOptions[key];
	      }
	    }
	
	    if (!options.cancelOnUserAction && options.passive) {
	      options.passive = false;
	      if (userOptions.passive) {
	        console && console.warn(
	          'animated-scroll-to:\n "passive" was set to "false" to prevent errors, ' +
	          'as using "cancelOnUserAction: false" doesn\'t work with passive events.')
	      }
	    }
	
	    if (desiredOffset instanceof HTMLElement) {
	      if (userOptions.element && userOptions.element instanceof HTMLElement) {
	        if (options.horizontal) {
	          desiredOffset = (desiredOffset.getBoundingClientRect().left + userOptions.element.scrollLeft)
	            - userOptions.element.getBoundingClientRect().left;
	        } else {
	          desiredOffset = (desiredOffset.getBoundingClientRect().top + userOptions.element.scrollTop)
	            - userOptions.element.getBoundingClientRect().top;
	        }
	      } else if (options.horizontal) {
	        var scrollLeft = window.scrollX || document.documentElement.scrollLeft;
	        desiredOffset = scrollLeft + desiredOffset.getBoundingClientRect().left;
	      } else {
	        var scrollTop = window.scrollY || document.documentElement.scrollTop;
	        desiredOffset = scrollTop + desiredOffset.getBoundingClientRect().top;
	      }
	    }
	
	    // Add additonal user offset
	    desiredOffset += options.offset
	
	    options.isWindow = options.element === window;
	
	    var initialScrollPosition = null;
	    var initialAxisScollPosition = 0;
	    var maxScroll = null;
	
	    if (options.isWindow) {
	      if (options.horizontal) {
	        // get cross browser scroll positions
	        initialScrollPosition = window.scrollX || document.documentElement.scrollLeft;
	        initialAxisScollPosition = window.scrollY || document.documentElement.scrollTop;
	        // cross browser document height minus window height
	        maxScroll = Math.max(
	          document.body.scrollWidth, document.documentElement.scrollWidth,
	          document.body.offsetWidth, document.documentElement.offsetWidth,
	          document.body.clientWidth, document.documentElement.clientWidth
	        ) - window.innerWidth;
	      } else {
	        // get cross browser scroll positions
	        initialScrollPosition = window.scrollY || document.documentElement.scrollTop;
	        initialAxisScollPosition = window.scrollX || document.documentElement.scrollLeft;
	        // cross browser document width minus window width
	        maxScroll = Math.max(
	          document.body.scrollHeight, document.documentElement.scrollHeight,
	          document.body.offsetHeight, document.documentElement.offsetHeight,
	          document.body.clientHeight, document.documentElement.clientHeight
	        ) - window.innerHeight;
	      }
	    } else {
	      // DOM element
	      if (options.horizontal) {
	        initialScrollPosition = options.element.scrollLeft;
	        maxScroll = options.element.scrollWidth - options.element.clientWidth;
	      } else {
	        initialScrollPosition = options.element.scrollTop;
	        maxScroll = options.element.scrollHeight - options.element.clientHeight;
	      }
	    }
	
	    // If the scroll position is greater than maximum available scroll
	    if (desiredOffset > maxScroll) {
	      desiredOffset = maxScroll;
	    }
	
	    // Calculate diff to scroll
	    var diff = desiredOffset - initialScrollPosition;
	
	    // Do nothing if the page is already there
	    if (diff === 0) {
	      // Execute callback if there is any
	      if (options.onComplete && typeof options.onComplete === 'function') {
	        options.onComplete()
	      }
	
	      return;
	    }
	
	    // Calculate duration of the scroll
	    var duration = Math.abs(Math.round((diff / 1000) * options.speed));
	
	    // Set minimum and maximum duration
	    if (duration < options.minDuration) {
	      duration = options.minDuration;
	    } else if (duration > options.maxDuration) {
	      duration = options.maxDuration;
	    }
	
	    var startingTime = Date.now();
	
	    // Request animation frame ID
	    var requestID = null;
	
	    // Method handler
	    var handleUserEvent = null;
	    var userEventOptions = { passive: options.passive };
	
	    if (options.cancelOnUserAction) {
	      // Set handler to cancel scroll on user action
	      handleUserEvent = function() {
	        removeListeners();
	        cancelAnimationFrame(requestID);
	      };
	      window.addEventListener('keydown', handleUserEvent, userEventOptions);
	      window.addEventListener('mousedown', handleUserEvent, userEventOptions);
	    } else {
	      // Set handler to prevent user actions while scroll is active
	      handleUserEvent = function(e) { e.preventDefault(); };
	      window.addEventListener('scroll', handleUserEvent, userEventOptions);
	    }
	
	    window.addEventListener('wheel', handleUserEvent, userEventOptions);
	    window.addEventListener('touchstart', handleUserEvent, userEventOptions);
	
	    var removeListeners = function () {
	      window.removeEventListener('wheel', handleUserEvent, userEventOptions);
	      window.removeEventListener('touchstart', handleUserEvent, userEventOptions);
	
	      if (options.cancelOnUserAction) {
	        window.removeEventListener('keydown', handleUserEvent, userEventOptions);
	        window.removeEventListener('mousedown', handleUserEvent, userEventOptions);
	      } else {
	        window.removeEventListener('scroll', handleUserEvent, userEventOptions);
	      }
	    };
	
	    var step = function () {
	      var timeDiff = Date.now() - startingTime;
	      var t = (timeDiff / duration) - 1;
	      var easing = t * t * t + 1;
	      var scrollPosition = Math.round(initialScrollPosition + (diff * easing));
	
	      var doScroll = function(position) {
	        if (options.isWindow) {
	          if (options.horizontal) {
	            options.element.scrollTo(position, initialAxisScollPosition);
	          } else {
	            options.element.scrollTo(initialAxisScollPosition, position);
	          }
	        } else if (options.horizontal) {
	          options.element.scrollLeft = position;
	        } else {
	          options.element.scrollTop = position;
	        }
	      }
	
	      if (timeDiff < duration && scrollPosition !== desiredOffset) {
	        // If scroll didn't reach desired offset or time is not elapsed
	        // Scroll to a new position
	        // And request a new step
	        doScroll(scrollPosition);
	
	        requestID = requestAnimationFrame(step);
	      } else {
	        // If the time elapsed or we reached the desired offset
	        // Set scroll to the desired offset (when rounding made it to be off a pixel or two)
	        // Clear animation frame to be sure
	        doScroll(desiredOffset);
	
	        cancelAnimationFrame(requestID);
	
	        // Remove listeners
	        removeListeners();
	
	        // Animation is complete, execute callback if there is any
	        if (options.onComplete && typeof options.onComplete === 'function') {
	          options.onComplete()
	        }
	      }
	    };
	
	    // Start animating scroll
	    requestID = requestAnimationFrame(step);
	  }
	
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      module.exports = __ANIMATE_SCROLL_TO;
	      exports = module.exports;
	    }
	    exports.default = __ANIMATE_SCROLL_TO;
	  } else if (window) {
	    window.animateScrollTo = __ANIMATE_SCROLL_TO;
	  }
	}).call(this);


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(8)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collapse = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SPRING_PRECISION = 1;
	
	var WAITING = 'WAITING';
	var RESIZING = 'RESIZING';
	var RESTING = 'RESTING';
	var IDLING = 'IDLING';
	
	var noop = function noop() {
	  return null;
	};
	var css = {
	  collapse: 'ReactCollapse--collapse',
	  content: 'ReactCollapse--content'
	};
	
	var Collapse = exports.Collapse = function (_React$PureComponent) {
	  _inherits(Collapse, _React$PureComponent);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      currentState: IDLING,
	      from: 0,
	      to: 0
	    };
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isOpened = _props.isOpened,
	          forceInitialAnimation = _props.forceInitialAnimation,
	          onRest = _props.onRest;
	
	      if (isOpened) {
	        var to = this.getTo();
	        if (forceInitialAnimation) {
	          var from = this.wrapper.clientHeight;
	          this.setState({ currentState: RESIZING, from: from, to: to });
	        } else {
	          this.setState({ currentState: IDLING, from: to, to: to });
	        }
	      }
	      onRest();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasNestedCollapse) {
	        // For nested collapses we do not need to change to waiting state
	        // and should keep `height:auto`
	        // Because children will be animated and height will not jump anyway
	        // See https://github.com/nkbt/react-collapse/issues/76 for more details
	        if (nextProps.isOpened !== this.props.isOpened) {
	          // Still go to WAITING state if own isOpened was changed
	          this.setState({ currentState: WAITING });
	        }
	      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
	        this.setState({ currentState: WAITING });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_, prevState) {
	      var _props2 = this.props,
	          isOpened = _props2.isOpened,
	          onRest = _props2.onRest,
	          onMeasure = _props2.onMeasure;
	
	
	      if (this.state.currentState === IDLING) {
	        onRest();
	        return;
	      }
	
	      if (prevState.to !== this.state.to) {
	        onMeasure({ height: this.state.to, width: this.content.clientWidth });
	      }
	
	      var from = this.wrapper.clientHeight;
	      var to = isOpened ? this.getTo() : 0;
	
	      if (from !== to) {
	        this.setState({ currentState: RESIZING, from: from, to: to });
	        return;
	      }
	
	      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
	        this.setState({ currentState: IDLING, from: from, to: to });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      cancelAnimationFrame(this.raf);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
	        onRest: this.onRest,
	        children: this.renderContent }));
	    }
	  }]);
	
	  return Collapse;
	}(_react2.default.PureComponent);
	
	Collapse.propTypes = {
	  isOpened: _propTypes2.default.bool.isRequired,
	  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
	  forceInitialAnimation: _propTypes2.default.bool,
	
	  hasNestedCollapse: _propTypes2.default.bool,
	
	  fixedHeight: _propTypes2.default.number,
	
	  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
	  style: _propTypes2.default.object,
	
	  onRender: _propTypes2.default.func,
	  onRest: _propTypes2.default.func,
	  onMeasure: _propTypes2.default.func,
	
	  children: _propTypes2.default.node.isRequired
	};
	Collapse.defaultProps = {
	  forceInitialAnimation: false,
	  hasNestedCollapse: false,
	  fixedHeight: -1,
	  style: {},
	  theme: css,
	  onRender: noop,
	  onRest: noop,
	  onMeasure: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onContentRef = function (content) {
	    _this2.content = content;
	  };
	
	  this.onWrapperRef = function (wrapper) {
	    _this2.wrapper = wrapper;
	  };
	
	  this.onRest = function () {
	    _this2.raf = requestAnimationFrame(_this2.setResting);
	  };
	
	  this.setResting = function () {
	    _this2.setState({ currentState: RESTING });
	  };
	
	  this.getTo = function () {
	    var fixedHeight = _this2.props.fixedHeight;
	
	    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
	  };
	
	  this.getWrapperStyle = function (height) {
	    if (_this2.state.currentState === IDLING && _this2.state.to) {
	      var fixedHeight = _this2.props.fixedHeight;
	
	      if (fixedHeight > -1) {
	        return { overflow: 'hidden', height: fixedHeight };
	      }
	      return { height: 'auto' };
	    }
	
	    if (_this2.state.currentState === WAITING && !_this2.state.to) {
	      return { overflow: 'hidden', height: 0 };
	    }
	
	    return { overflow: 'hidden', height: Math.max(0, height) };
	  };
	
	  this.getMotionProps = function () {
	    var springConfig = _this2.props.springConfig;
	
	
	    return _this2.state.currentState === IDLING ? {
	      // When completely stable, instantly jump to the position
	      defaultStyle: { height: _this2.state.to },
	      style: { height: _this2.state.to }
	    } : {
	      // Otherwise, animate
	      defaultStyle: { height: _this2.state.from },
	      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
	    };
	  };
	
	  this.renderContent = function (_ref) {
	    var height = _ref.height;
	
	    // eslint-disable-line
	    var _props3 = _this2.props,
	        _isOpened = _props3.isOpened,
	        _springConfig = _props3.springConfig,
	        _forceInitialAnimation = _props3.forceInitialAnimation,
	        _hasNestedCollapse = _props3.hasNestedCollapse,
	        _fixedHeight = _props3.fixedHeight,
	        theme = _props3.theme,
	        style = _props3.style,
	        onRender = _props3.onRender,
	        _onRest = _props3.onRest,
	        _onMeasure = _props3.onMeasure,
	        children = _props3.children,
	        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);
	
	    var _state = _this2.state,
	        from = _state.from,
	        to = _state.to;
	
	    // DANGEROUS, use with caution, never do setState with it
	
	    onRender({ current: height, from: from, to: to });
	
	    return _react2.default.createElement(
	      'div',
	      _extends({
	        ref: _this2.onWrapperRef,
	        className: theme.collapse,
	        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
	      }, props),
	      _react2.default.createElement(
	        'div',
	        { ref: _this2.onContentRef, className: theme.content },
	        children
	      )
	    );
	  };
	};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UnmountClosed = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
	  _inherits(UnmountClosed, _React$PureComponent);
	
	  function UnmountClosed(props) {
	    _classCallCheck(this, UnmountClosed);
	
	    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));
	
	    _this.componentWillReceiveProps = function (_ref) {
	      var isOpened = _ref.isOpened;
	
	      if (!_this.props.isOpened && isOpened) {
	        _this.setState({
	          forceInitialAnimation: true,
	          shouldUnmount: false
	        });
	      }
	    };
	
	    _this.onRest = function () {
	      var _this$props = _this.props,
	          isOpened = _this$props.isOpened,
	          onRest = _this$props.onRest;
	
	
	      if (!isOpened) {
	        _this.setState({ shouldUnmount: true });
	      }
	      if (onRest) {
	        onRest.apply(undefined, arguments);
	      }
	    };
	
	    _this.state = {
	      shouldUnmount: !_this.props.isOpened,
	      forceInitialAnimation: !_this.props.isOpened
	    };
	    return _this;
	  }
	
	  _createClass(UnmountClosed, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isOpened = _props.isOpened,
	          _onRest = _props.onRest,
	          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);
	
	      var _state = this.state,
	          forceInitialAnimation = _state.forceInitialAnimation,
	          shouldUnmount = _state.shouldUnmount;
	
	
	      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
	        forceInitialAnimation: forceInitialAnimation,
	        isOpened: isOpened,
	        onRest: this.onRest
	      }, props));
	    }
	  }]);
	
	  return UnmountClosed;
	}(_react2.default.PureComponent);
	
	UnmountClosed.propTypes = {
	  isOpened: _propTypes2.default.bool.isRequired,
	  onRest: _propTypes2.default.func
	};

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(31),
	    Collapse = _require.Collapse;
	
	var _require2 = __webpack_require__(46),
	    UnmountClosed = _require2.UnmountClosed;
	
	UnmountClosed.Collapse = Collapse;
	UnmountClosed.UnmountClosed = UnmountClosed;
	
	module.exports = UnmountClosed;

/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=a())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,a){var t=!String(e).split(".")[1];return a?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},"year-short":{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},"month-short":{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},"day-short":{displayName:"g",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} g",other:"tra {0} gg"},past:{one:"{0} g fa",other:"{0} gg fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},"hour-short":{displayName:"h.",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} h",other:"tra {0} h"},past:{one:"{0} h fa",other:"{0} h fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},"minute-short":{displayName:"min",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} min",other:"tra {0} min"},past:{one:"{0} min fa",other:"{0} min fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}},"second-short":{displayName:"s",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} s",other:"tra {0} sec."},past:{one:"{0} s fa",other:"{0} sec. fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(16);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(9);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(18);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(8);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(15);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(17);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(16);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(9);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(18);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(8);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(15);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(17);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(16);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(9);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(18);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(52);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(8);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(15);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(17);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(49);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(50);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(51);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(55);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(32);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(9);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(54);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(32);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(3));
	
	var _addClass = _interopRequireDefault(__webpack_require__(210));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(211));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Transition = _interopRequireDefault(__webpack_require__(64));
	
	var _PropTypes = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation. After the animation,
	 * matching `done` class names are applied to persist the animation state.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var _this$getClassNames3 = _this.getClassNames('enter'),
	          doneClassName = _this$getClassNames3.doneClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          className = _this$getClassNames4.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames5.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames6 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames6.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames7 = this.getClassNames(type),
	        className = _this$getClassNames7.className,
	        activeClassName = _this$getClassNames7.activeClassName,
	        doneClassName = _this$getClassNames7.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or has finished the transition.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply spread
	   * them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = __webpack_require__(23);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(65));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _reactLifecyclesCompat = __webpack_require__(43);
	
	var _PropTypes = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?
	
	
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactLifecyclesCompat = __webpack_require__(43);
	
	var _ChildMapping = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(131));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(132));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(65));
	
	var _Transition = _interopRequireDefault(__webpack_require__(64));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCollapse = __webpack_require__(47);
	
	__webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Il componente che renderizza un singolo libro
	var Collapsible = function (_Component) {
	  _inherits(Collapsible, _Component);
	
	  function Collapsible() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Collapsible);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isHover: false,
	      isOpened: false
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ isHover: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ isHover: false });
	    }, _this.handleClick = function () {
	      _this.setState({ isOpened: !_this.state.isOpened });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Collapsible.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        children = _props.children,
	        collapsedIcon = _props.collapsedIcon,
	        expandedIcon = _props.expandedIcon,
	        expandedColor = _props.expandedColor,
	        collapsedColor = _props.collapsedColor,
	        titlePaddingLeft = _props.titlePaddingLeft,
	        isOpened = _props.isOpened,
	        _onClick = _props.onClick;
	    var isHover = this.state.isHover;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'a',
	        {
	          className: 'Collapsible ' + (isOpened || this.state.isOpened ? 'Collapsible--open' : ''),
	          onClick: function onClick() {
	            _onClick ? _onClick(_this2.props.id) : _this2.handleClick();
	          },
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: {
	            paddingLeft: titlePaddingLeft ? titlePaddingLeft : 'auto'
	          },
	          id: '' + this.props.id
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'Collapsible__Title text-bold',
	            style: {
	              color: isOpened || isHover ? expandedColor : collapsedColor
	            }
	          },
	          title()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Collapsible__PlusIconContainer' },
	          !isOpened && !isHover && collapsedIcon && _react2.default.createElement('img', { src: collapsedIcon, className: 'Collapsible__PlusIcon' }),
	          (isOpened || isHover) && expandedIcon && _react2.default.createElement('img', { src: expandedIcon, className: 'Collapsible__PlusIcon' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactCollapse.Collapse,
	        { isOpened: isOpened || this.state.isOpened },
	        children
	      )
	    );
	  };
	
	  return Collapsible;
	}(_react.Component);
	
	exports.default = Collapsible;
	module.exports = exports['default'];

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(27);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactIntl = __webpack_require__(10);
	
	var _instagram = __webpack_require__(260);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	__webpack_require__(229);
	
	var _collapsible = __webpack_require__(44);
	
	var _collapsible2 = _interopRequireDefault(_collapsible);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Footer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      panels: {
	        links: true,
	        contatti: true
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Footer.prototype.render = function render() {
	    var logoImg = this.props.allImages.find(function (edge) {
	      return edge.node.sizes.src.indexOf('logo-usi') >= 0;
	    });
	
	    return _react2.default.createElement(
	      'footer',
	      { className: 'Footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Footer__Mobile' },
	        _react2.default.createElement(
	          _collapsible2.default,
	          {
	            id: 'links',
	            isOpened: this.state.panels['links'],
	            title: function title() {
	              return _react2.default.createElement(
	                'div',
	                { className: 'Footer__Collapsible__Title' },
	                'Links'
	              );
	            },
	            expandedColor: 'white',
	            collapsedColor: 'white'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'Footer__Mobile__Collpase__Content' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.archiviodelmoderno.org/' },
	                'Archivio del Moderno'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.arc.usi.ch/it' },
	                'Accademia di architettura'
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { target: '_blank', href: 'https://www.instagram.com/ticino4580/' },
	              _react2.default.createElement('img', { className: 'Footer__Insta', src: _instagram2.default })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _collapsible2.default,
	          {
	            id: 'contatti',
	            isOpened: this.state.panels['contatti'],
	            onClick: this.handleCollapsibleClick,
	            title: function title() {
	              return _react2.default.createElement(
	                'div',
	                { className: 'Footer__Collapsible__Title' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.contatti' })
	              );
	            },
	            expandedColor: 'white',
	            collapsedColor: 'white'
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'Footer__Mobile__Collpase__Content text-white' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Telefono: + 41 58 666 55 00'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Mail: archivio.arc@usi.ch'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Via Magazzini Generali 14'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              '6828 Balerna (Svizzera)'
	            ),
	            _react2.default.createElement(_gatsbyImage2.default, {
	              className: 'mt-2',
	              sizes: logoImg.node.sizes,
	              style: { width: '160px' }
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Footer__Desktop wrap-narrower' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Footer__Left' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Footer__Heading' },
	            'Links'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.archiviodelmoderno.org/' },
	              'Archivio del Moderno'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.arc.usi.ch/it' },
	              'Accademia di architettura'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://www.instagram.com/ticino4580/' },
	            _react2.default.createElement('img', { className: 'Footer__Insta', src: _instagram2.default })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Footer__Right' },
	          _react2.default.createElement(
	            'div',
	            { className: 'Footer__Heading' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.contatti' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text-white' },
	            _react2.default.createElement(
	              'div',
	              null,
	              'Telefono: + 41 58 666 55 00'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Mail: archivio.arc@usi.ch'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Via Magazzini Generali 14'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              '6828 Balerna (Svizzera)'
	            )
	          ),
	          _react2.default.createElement(_gatsbyImage2.default, {
	            className: 'mt-2',
	            sizes: logoImg.node.sizes,
	            style: { width: '160px' }
	          })
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(27);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridItem = function (_Component) {
	  _inherits(GridItem, _Component);
	
	  function GridItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GridItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isHover: false
	    }, _this.addHover = function () {
	      _this.setState({ isHover: true });
	    }, _this.removeHover = function () {
	      _this.setState({ isHover: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GridItem.prototype.render = function render() {
	    var _props = this.props,
	        imageMap = _props.imageMap,
	        link = _props.link,
	        className = _props.className;
	    var isHover = this.state.isHover;
	
	    var title = link;
	
	    if (link === 'progetto') {
	      title = 'Il Progetto';
	    }
	
	    if (link === 'relazioni-e-conferenze') {
	      title = 'Relazioni e conferenze';
	    }
	
	    var locale = 'it';
	
	    if (typeof window !== 'undefined') {
	      locale = window.localStorage.getItem('locale');
	    }
	
	    var linkPrefix = locale === 'it' ? '' : '/en';
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        to: linkPrefix + '/' + link,
	        className: 'LinksGrid__Item ' + (className || ''),
	        onMouseEnter: this.addHover,
	        onMouseLeave: this.removeHover,
	        onClick: this.removeHover
	      },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        critical: true,
	        sizes: imageMap[link].node.sizes,
	        style: {
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%',
	          zIndex: isHover ? -1 : 0
	        }
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        fadeIn: false,
	        sizes: imageMap[link + 'Hover'].node.sizes,
	        onLoad: this.stopPreloading,
	        style: {
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%',
	          zIndex: isHover ? 0 : -1
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'LinksGrid__Item__Title' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'gridItem.' + link })
	      )
	    );
	  };
	
	  return GridItem;
	}(_react.Component);
	
	exports.default = GridItem;
	module.exports = exports['default'];

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(27);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _animatedScrollTo = __webpack_require__(68);
	
	var _animatedScrollTo2 = _interopRequireDefault(_animatedScrollTo);
	
	var _reactIntl = __webpack_require__(10);
	
	__webpack_require__(230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChevronIconClick = function () {
	      (0, _animatedScrollTo2.default)(document.querySelector('.Main'));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Header.prototype.render = function render() {
	    var headerImage = this.props.images.find(function (image) {
	      return image.node.sizes.src.indexOf('splash') >= 0;
	    });
	
	    var trianglesArray = Array.from({ length: 50 }, function (x, i) {
	      return i;
	    });
	
	    return _react2.default.createElement(
	      'header',
	      { className: 'Header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Header__Left' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Header__Left__Title' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.title.firstLine' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.title.secondLine' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.title.thirdLine' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.title.fourthLine' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Header__Left__ArrowContainer' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'Header__Left__Arrow',
	              onClick: this.handleChevronIconClick
	            },
	            _react2.default.createElement(
	              'svg',
	              {
	                className: 'bounce',
	                xmlns: 'http://www.w3.org/2000/svg',
	                viewBox: '0 0 50 50'
	              },
	              _react2.default.createElement('line', { x1: '2.5', y1: '25', x2: '25', y2: '48' }),
	              _react2.default.createElement('line', { x1: '25', y1: '48', x2: '47.5', y2: '25' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Header__Right' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Header__Triangles__Right' },
	          trianglesArray.map(function (triangle, i) {
	            return _react2.default.createElement('div', { key: i, className: 'triangle-right' });
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Header__Triangles__Down' },
	          trianglesArray.map(function (triangle, i) {
	            return _react2.default.createElement('div', {
	              key: i,
	              style: {
	                position: 'absolute',
	                top: '-18px',
	                left: 49 * i + 'px',
	                transform: 'rotate(-45deg)'
	              },
	              className: 'triangle-down'
	            });
	          })
	        ),
	        _react2.default.createElement(_gatsbyImage2.default, {
	          sizes: headerImage.node.sizes,
	          style: {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: '100%',
	            height: '100%'
	          }
	        })
	      )
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gridItem = __webpack_require__(94);
	
	var _gridItem2 = _interopRequireDefault(_gridItem);
	
	__webpack_require__(231);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinksGrid = function (_Component) {
	  _inherits(LinksGrid, _Component);
	
	  function LinksGrid() {
	    _classCallCheck(this, LinksGrid);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  LinksGrid.prototype.render = function render() {
	    var _props = this.props,
	        imageMap = _props.imageMap,
	        links = _props.links;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'bg-primary py-2 mt-4' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrap-narrower' },
	        _react2.default.createElement(
	          'div',
	          { className: 'LinksGrid__Title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'links.continuaANavigare' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'LinksGrid mt-2' },
	          links.map(function (link, i) {
	            return _react2.default.createElement(_gridItem2.default, {
	              key: i,
	              link: link,
	              imageMap: imageMap,
	              className: 'LinksGrid__Item--small'
	            });
	          })
	        )
	      )
	    );
	  };
	
	  return LinksGrid;
	}(_react.Component);
	
	exports.default = LinksGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _arrowRight = __webpack_require__(139);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _reactIntl = __webpack_require__(10);
	
	__webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(_ref) {
	  var onLinkClick = _ref.onLinkClick,
	      locale = _ref.locale;
	
	  var linkPrefix = locale === 'it' ? '' : '/en';
	  var otherLanguage = locale === 'it' ? '/en' : '/';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Menu' },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrap' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Menu__Row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Menu__Column Menu__Column--left' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: linkPrefix + '/', onClick: onLinkClick },
	            _react2.default.createElement(
	              'h1',
	              { className: 'text-bold' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.heading.firstLine' }),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.heading.secondLine' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Menu__Column Menu__Column--right' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: linkPrefix + '/',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            'Home Page',
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: linkPrefix + '/progetto',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.progetto' }),
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: linkPrefix + '/eventi',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.eventi' }),
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: linkPrefix + '/pubblicazioni',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.pubblicazioni' }),
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: linkPrefix + '/mappe',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.mappe' }),
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: linkPrefix + '/interviste',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.interviste' }),
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: linkPrefix + '/relazioni-e-conferenze',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.relazioniEConferenze' }),
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: linkPrefix + '/gruppo-di-ricerca',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.gruppoDiRicerca' }),
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: linkPrefix + '/contatti',
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'menu.contatti' }),
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              href: '' + otherLanguage,
	              className: 'Menu__Link',
	              onClick: onLinkClick
	            },
	            locale === 'it' && _react2.default.createElement(
	              'span',
	              null,
	              'English'
	            ),
	            locale === 'en' && _react2.default.createElement(
	              'span',
	              null,
	              'Italiano'
	            ),
	            _react2.default.createElement('img', { src: _arrowRight2.default, alt: 'Arrow icon' })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTransitionGroup = __webpack_require__(78);
	
	var _triangle = __webpack_require__(262);
	
	var _triangle2 = _interopRequireDefault(_triangle);
	
	var _triangleOrange = __webpack_require__(261);
	
	var _triangleOrange2 = _interopRequireDefault(_triangleOrange);
	
	var _menu = __webpack_require__(181);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	__webpack_require__(233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Nav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { isMenuVisible: false, isTriangleHover: false }, _this.toggleMenu = function () {
	      _this.setState({ isMenuVisible: !_this.state.isMenuVisible }, function () {
	        if (_this.state.isMenuVisible) {
	          return document.body.style.overflow = 'hidden';
	        }
	
	        document.body.style.overflow = 'auto';
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Nav.prototype.render = function render() {
	    var _this2 = this;
	
	    var triangleImageSrc = this.state.isTriangleHover ? _triangleOrange2.default : _triangle2.default;
	
	    var _props = this.props,
	        visible = _props.visible,
	        locale = _props.locale;
	
	    var linkPrefix = locale === 'it' ? '' : '/en';
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'Nav ' + (visible ? 'Nav--visible' : '') },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'hamburger hamburger--slider ' + (this.state.isMenuVisible ? 'is-active' : ''),
	            type: 'button',
	            onClick: this.toggleMenu
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'hamburger-box' },
	            _react2.default.createElement('span', { className: 'hamburger-inner' })
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: linkPrefix + '/',
	            onMouseEnter: function onMouseEnter() {
	              return _this2.setState({ isTriangleHover: true });
	            },
	            onMouseLeave: function onMouseLeave() {
	              return _this2.setState({ isTriangleHover: false });
	            }
	          },
	          _react2.default.createElement('img', {
	            className: 'Nav__Triangle',
	            src: triangleImageSrc,
	            alt: 'Click to go to home page'
	          })
	        ),
	        _react2.default.createElement('div', { style: { width: '50px' } })
	      ),
	      _react2.default.createElement(
	        _reactTransitionGroup.CSSTransition,
	        {
	          'in': this.state.isMenuVisible,
	          timeout: 200,
	          classNames: 'Nav__MenuContainer',
	          unmountOnExit: true
	        },
	        _react2.default.createElement(_menu2.default, { locale: locale, onLinkClick: this.toggleMenu })
	      )
	    );
	  };
	
	  return Nav;
	}(_react.Component);
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollTrack = function (_Component) {
	  _inherits(ScrollTrack, _Component);
	
	  function ScrollTrack() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollTrack);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { amountscrolled: 0 }, _this.handleWindowResize = function () {
	      _this.getmeasurements();
	      requestAnimationFrame(_this.amountscrolled);
	    }, _this.handleScroll = function () {
	      requestAnimationFrame(_this.amountscrolled);
	    }, _this.getmeasurements = function () {
	      var winheight = window.innerHeight || (document.documentElement || document.body).clientHeight;
	
	      var docheight = _this.getDocHeight();
	      _this.trackLength = docheight - winheight;
	    }, _this.getDocHeight = function () {
	      var D = document;
	
	      return Math.max(D.body.scrollHeight, D.documentElement.scrollHeight, D.body.offsetHeight, D.documentElement.offsetHeight, D.body.clientHeight, D.documentElement.clientHeight);
	    }, _this.amountscrolled = function () {
	      var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
	      var pctScrolled = Math.floor(scrollTop / _this.trackLength * 100);
	      _this.setState({ amountscrolled: pctScrolled });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScrollTrack.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.getmeasurements();
	
	      if (typeof window !== 'undefined') {
	        window.addEventListener('resize', _this2.handleWindowResize);
	        window.addEventListener('scroll', _this2.handleScroll);
	      }
	    }, 1000);
	  };
	
	  ScrollTrack.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (typeof window !== 'undefined') {
	      window.removeEventListener('resize', this.handleWindowResize);
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  };
	
	  ScrollTrack.prototype.render = function render() {
	    return _react2.default.createElement('div', {
	      className: 'Nav__ScrollTrack',
	      style: { width: this.state.amountscrolled + '%' }
	    });
	  };
	
	  return ScrollTrack;
	}(_react.Component);
	
	exports.default = ScrollTrack;
	module.exports = exports['default'];

/***/ }),

/***/ 966:
/***/ (function(module, exports) {

	module.exports = {"header.title.firstLine":"L'architettura","header.title.secondLine":"nel Cantone","header.title.thirdLine":"Ticino,","header.title.fourthLine":"1945 - 1980","home.smallprint":"Progetto finanziato dal Fondo Nazionale Svizzero per la Ricerca Scientifica, promosso dall'Archivio del Moderno, Accademia di architettura - Università della Svizzera Italiana. ","menu.progetto":"Il Progetto","menu.eventi":"Eventi","menu.relazioniEConferenze":"Relazioni e Conferenze","menu.pubblicazioni":"Pubblicazioni","menu.mappe":"Guida","menu.interviste":"Interviste","menu.gruppoDiRicerca":"Gruppo di Ricerca","menu.contatti":"Contatti","menu.heading.firstLine":"L'architettura nel Cantone Ticino,","menu.heading.secondLine":"1945 - 1980","gridItem.progetto":"Il Progetto","gridItem.mappe":"Guida","gridItem.interviste":"Interviste","gridItem.eventi":"Eventi","gridItem.relazioni-e-conferenze":"Relazioni e Conferenze","gridItem.pubblicazioni":"Pubblicazioni","pubblicazioni.libri":"Libri","pubblicazioni.articoli":"Articoli","links.continuaANavigare":"Continua a navigare","mappe.tipologia":"Tipologia","mappe.autore":"Autore","mappe.filtra":"Filtra","mappe.luogo":"Luogo","mappe.periodo":"Periodo"}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUY0REFFNzkyQTFFMTFFOUI3MkZBMUFFRTIwNTZBNzQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUY0REFFN0EyQTFFMTFFOUI3MkZBMUFFRTIwNTZBNzQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBRjREQUU3NzJBMUUxMUU5QjcyRkExQUVFMjA1NkE3NCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBRjREQUU3ODJBMUUxMUU5QjcyRkExQUVFMjA1NkE3NCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PtH2LdgAAAG8SURBVHja7JqBjYMwDEXhJuhtkBE6AiN0hIzQEdigIzBCR8gIjMAI3AZcW4UKcYYm+P9rUmHJUgWKmpc4/rHbchiG4hOs3EF2EJLdQYgw9ua9d0udPxHEeIDBe++fZQfSTCBGb3IDMQLE6CYnELcC4nIBqVYgRq9yAGlnk+68T5+1qYPYhdWXdsmmCnIQVt6tnJvOj0kOpBZW/Th5fxTe16mBHGbit6QZc23ptbuCBmkC9cKgRRIJYiJDpkaKJBLkGhkuUhhe3w0ipdVzwLgzSiRRIFJKDbUOcXVBgEjid4oYf0KIJAIEsaKaHYWA1KAYr7QiqQEJFb+tGhQlkhqQC7hYknTowgZRfSljcbaCwO9K2nDdAqI+mIwEsgVEnSoZKT0WBCJeDJGNBYFcJxgiGQMCu+AxLqKhINArN6M0CAWBFkGMYi0EBF6WMsrnEBCW+EFF8hUIpXVDaDG9BKE00whNv1UQWnsTKJJVCAit4aywdkkkl0DsP4ufRiTtEoiUJVyRjjkpi0ogUoZI3etx/s/f2cuy7N+UmTT2c5v/9/3DV/EpNgktK5yRlP3xJ4Q/oZW77SA7CMl+BRgAEHejfoKxjNkAAAAASUVORK5CYII="

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+CiAgPGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjYiIHgxPSIzIiB5MT0iMjUiIHgyPSI0NyIgeTI9IjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8bGluZSBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iNiIgeDE9IjQ3IiB5MT0iMjUiIHgyPSIyNSIgeTI9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogIDxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSI2IiB4MT0iNDciIHkxPSIyNSIgeDI9IjI1IiB5Mj0iNDciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+CiAgPGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZDk2ZDUwIiBzdHJva2Utd2lkdGg9IjQiIHgxPSI0IiB5MT0iNDYiIHgyPSI0NiIgeTI9IjQ2IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8bGluZSBmaWxsPSJub25lIiBzdHJva2U9IiNkOTZkNTAiIHN0cm9rZS13aWR0aD0iNCIgeDE9IjQ2IiB5MT0iNDYiIHgyPSIyNSIgeTI9IjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogIDxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2Q5NmQ1MCIgc3Ryb2tlLXdpZHRoPSI0IiB4MT0iMjUiIHkxPSI4IiB4Mj0iNCIgeTI9IjQ2IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+CiAgPGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjQiIHgxPSI0IiB5MT0iNDYiIHgyPSI0NiIgeTI9IjQ2IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8bGluZSBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iNCIgeDE9IjQ2IiB5MT0iNDYiIHgyPSIyNSIgeTI9IjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogIDxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSI0IiB4MT0iMjUiIHkxPSI4IiB4Mj0iNCIgeTI9IjQ2IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(179);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(178);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _nav = __webpack_require__(182);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	__webpack_require__(236);
	
	var _scrollTrack = __webpack_require__(183);
	
	var _scrollTrack2 = _interopRequireDefault(_scrollTrack);
	
	var _linksGrid = __webpack_require__(180);
	
	var _linksGrid2 = _interopRequireDefault(_linksGrid);
	
	var _withRouter = __webpack_require__(255);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	var _reactTransitionGroup = __webpack_require__(78);
	
	var _reactIntl = __webpack_require__(10);
	
	var _favicon = __webpack_require__(259);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransitionHandler = function (_React$Component) {
	  _inherits(TransitionHandler, _React$Component);
	
	  function TransitionHandler() {
	    _classCallCheck(this, TransitionHandler);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TransitionHandler.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return this.props.location.pathname === window.location.pathname;
	  };
	
	  TransitionHandler.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'transition-container' },
	      children
	    );
	  };
	
	  return TransitionHandler;
	}(_react2.default.Component);
	
	var Layout = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout() {
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, Layout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this2), _this2.lastKnownScrollPosition = 0, _this2.isTicking = false, _this2.scrollThreshold = 0, _this2.vieportHeight = 0, _this2.isHomepage = typeof location !== 'undefined' && (location.pathname === '/' || location.pathname === '/en' || location.pathname === '/en/'), _this2.state = {
	      isNavVisible: typeof location === 'undefined' || _this2.isHomepage ? false : true
	    }, _this2.handleScroll = function () {
	      var isHomepage = location.pathname === '/' || location.pathname === '/en' || location.pathname === '/en/';
	
	      _this2.lastKnownScrollPosition = window.scrollY;
	      // Imposto la scrollThreshold all'altezza del viewport solo se sono
	      // in home. In tutte le altre pagine la nav deve essere sempre visibile
	      _this2.scrollThreshold = isHomepage ? 10 : 0;
	
	      if (!_this2.isTicking) {
	        window.requestAnimationFrame(function () {
	          _this2.checkNavVisibility(_this2.lastKnownScrollPosition);
	          _this2.isTicking = false;
	        });
	
	        _this2.isTicking = true;
	      }
	    }, _this2.checkNavVisibility = function (scrollPosition) {
	      if (scrollPosition >= _this2.scrollThreshold && !_this2.state.isNavVisible) {
	        return _this2.setState({ isNavVisible: true });
	      }
	
	      if (scrollPosition < _this2.scrollThreshold && _this2.state.isNavVisible) {
	        _this2.setState({ isNavVisible: false });
	      }
	    }, _this2.renderGrid = function (location, data, locale) {
	      var locationArray = location.pathname.split('/');
	      var currentPage = locationArray[1] === '' ? '/' : locationArray[1];
	
	      if (locale === 'en') {
	        currentPage = locationArray[2] === '' ? '/' : locationArray[2];
	      }
	
	      var allImages = data.allImageSharp.edges;
	
	      var imageMap = {
	        interviste: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('interviste_base') >= 0;
	        }),
	        intervisteHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('interviste_hover') >= 0;
	        }),
	        mappe: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('mappe_base') >= 0;
	        }),
	        mappeHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('mappe_hover') >= 0;
	        }),
	        eventi: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('eventi_base') >= 0;
	        }),
	        eventiHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('eventi_hover') >= 0;
	        }),
	        pubblicazioni: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('pubblicazioni_base') >= 0;
	        }),
	        pubblicazioniHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('pubblicazioni_hover') >= 0;
	        }),
	        progetto: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('progetto_base') >= 0;
	        }),
	        progettoHover: allImages.find(function (image) {
	          return image.node.sizes.src.indexOf('progetto_hover') >= 0;
	        })
	      };
	
	      switch (currentPage) {
	        case 'progetto':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['eventi', 'mappe', 'interviste', 'pubblicazioni']
	          });
	        case 'eventi':
	        case 'relazioni-e-conferenze':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['progetto', 'mappe', 'interviste', 'pubblicazioni']
	          });
	        case 'mappe':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['progetto', 'eventi', 'interviste', 'pubblicazioni']
	          });
	        case 'interviste':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['progetto', 'mappe', 'eventi', 'pubblicazioni']
	          });
	        case 'pubblicazioni':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['progetto', 'mappe', 'eventi', 'interviste']
	          });
	        case 'gruppo-di-ricerca':
	          return _react2.default.createElement(_linksGrid2.default, {
	            imageMap: imageMap,
	            links: ['eventi', 'mappe', 'interviste', 'pubblicazioni']
	          });
	      }
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  Layout.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      this.vieportHeight = window.innerHeight;
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  };
	
	  Layout.prototype.componendWillUnmount = function componendWillUnmount() {
	    if (typeof window !== 'undefined') {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  };
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        location = _props.location,
	        data = _props.data,
	        locale = _props.locale,
	        messages = _props.messages;
	
	
	    var isHomepage = location.pathname === '/' || location.pathname === '/en' || location.pathname === '/en/';
	
	    return _react2.default.createElement(
	      _reactIntl.IntlProvider,
	      { locale: locale, messages: messages },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          {
	            link: [{ rel: 'shortcut icon', type: 'image/png', href: '' + _favicon2.default }]
	          },
	          _react2.default.createElement(
	            'title',
	            null,
	            'Archivio Del Moderno | L\'architettura nel Cantone Ticino, 1945 - 1980'
	          )
	        ),
	        isHomepage && _react2.default.createElement(_header2.default, { locale: locale, images: data.allImageSharp.edges }),
	        _react2.default.createElement(_nav2.default, { locale: locale, visible: this.state.isNavVisible }),
	        location.pathname.startsWith('/progetto') && _react2.default.createElement(_scrollTrack2.default, null),
	        _react2.default.createElement(
	          _reactTransitionGroup.TransitionGroup,
	          null,
	          _react2.default.createElement(
	            _reactTransitionGroup.CSSTransition,
	            {
	              key: location.pathname,
	              classNames: 'fadein',
	              timeout: { enter: 200, exit: 100 }
	            },
	            _react2.default.createElement(
	              TransitionHandler,
	              { location: location },
	              _react2.default.createElement(
	                'main',
	                { className: 'Main' },
	                children(),
	                this.renderGrid(location, data, locale)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_footer2.default, { allImages: data.allImageSharp.edges })
	      )
	    );
	  };
	
	  return Layout;
	}(_react.Component);
	
	exports.default = (0, _withRouter2.default)(Layout);
	module.exports = exports['default'];

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(10);
	
	var _it = __webpack_require__(1205);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _index = __webpack_require__(184);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _it3 = __webpack_require__(966);
	
	var _it4 = _interopRequireDefault(_it3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactIntl.addLocaleData)(_it2.default);
	
	exports.default = function (props) {
	  if (typeof window !== 'undefined') {
	    window.localStorage.setItem('locale', 'it');
	  }
	
	  return _react2.default.createElement(_index2.default, _extends({}, props, { locale: 'it', messages: _it4.default }));
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-it-js-8fa1d8142f9283f60e45.js